import toast from 'react-hot-toast';
import instance from '../../apiInstance';

export const loginUser = async (body) => {
  try {
    const response = await instance({
      method: 'post',
      url: 'login',
      data: body,
    });
    return response.data.access_token;
  } catch (error) {
    const detail = error?.response?.data?.detail || 'Erro ao fazer login. Tente novamente.';
    toast.error(detail);
    throw error;
  }
};

export const registerUser = async (body) => {
  try {
    const response = await instance({
      method: 'post',
      url: 'register',
      data: body,
      headers: {Authorization:'Bearer'}
    });
    return response.data;
  } catch (error) {
    const detail = error?.response?.data?.detail || 'Erro ao registrar. Tente novamente.';
    toast.error(detail);
    throw error;
  }
};

export const submitTestimonial = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await instance.post('/submit_testimonial', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return response.data;
};

export const getMyTestimonial = async () => {
  const res = await instance.get('/my_testimonial');
  return res.data;
};
